export default __webpack_public_path__ + "static/media/fb.3e0808cb.webp";